import { triggerHostMessageOpenProviderMenu } from '../triggerHostMessage/triggerHostMessageOpenProviderMenu';
export default function openProviderMenuHandler() {
  triggerHostMessageOpenProviderMenu();
}